<template>
  <v-tooltip
    top
  >
    <template #activator="{ on, attrs }">
      <v-btn
        v-bind="attrs"
        outlined
        class="border btn-redirect"
        :disabled="!cycle.started"
        small
        :class="{
          'border-nitro': !cycle.is_current && cycle.started,
          'white--text border-white' : cycle.is_current ,
          'nitro--text' : !cycle.is_current,
        }"
          
        v-on="on"
        @click="onClick"
      >
        <v-icon style="font-size: 1.5em">
          fa fa-arrow-right
        </v-icon>
      </v-btn>
    </template>
    Ir para o {{ cycle.cycle_name }}
  </v-tooltip>
</template>

<script>
import { mapMutations } from 'vuex';
import { studyNowRouteName } from '@/student/constants/routes';

export default {
    props:{
        cycle: {
            required: true,
            type: Object,
        }
    },
    methods: {
        ...mapMutations(['SET_CYCLE']),
        onClick(){
            this.SET_CYCLE(this.cycle)
            this.$router.push({ name: studyNowRouteName })
        }
    }
}
</script>
<style lang="scss" scoped>
  button.btn-redirect {
    &:hover {
      background: #f74a4b;
      color:white;
      border: none;
      i {
        color: white
      }
    }
    i {
      font-size: 1em;
    }
  }
  
  button.v-btn:not(.v-btn--round).v-size--small {
    width: 35px !important;
    height: 25px !important;
    min-width: 35px !important;
  }


  @media screen and (min-width: 768px) {
    button.v-btn:not(.v-btn--round).v-size--small {
      height: 35px !important;
      width: 49px!important;
      min-width: 49px!important;
    }
  }
</style>